import React from 'react';
import FormStyles from "../form/fom.module.scss";



function Button(props) {
  const { label, onClick, state } = props;

  // const { register } = useFormContext();
  
  return (
    <div className="">
      <button
        type="submit"
        value="Submit"
        className={`${FormStyles.button} ${FormStyles.tabclix__w_button}`}
        onClick={onClick}
        name="Mybutton"
        // {...register(`Mybutton`)}
        disabled={state}
      >
        {state?  <span>Sending <div className={`${FormStyles.spinner}`}></div></span>  : label ? label : 'Submit'}
      </button>
      
    </div>
  );
}

export default Button